import { render, staticRenderFns } from "./confirm-cancel-upload.vue?vue&type=template&id=36884626&scoped=true&"
import script from "./confirm-cancel-upload.vue?vue&type=script&lang=js&"
export * from "./confirm-cancel-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36884626",
  null
  
)

export default component.exports